<div class="rb-list">
  @for (fg of field.fieldGroup; track fg; let i = $index) {
    <div
      class="rb-item"
      [ngClass]="{ 'rb-item--rule': isRule(i), 'rb-item--group': !isRule(i) }">
      <!-- remove button for GROUPS (uses FieldArrayType.remove) -->
      @if (!isRule(i)) {
        <button
          type="button"
          class="rb-item__remove"
          mat-icon-button
          matTooltip="Remove group"
          (click)="remove(i)">
          <mat-icon>close</mat-icon>
        </button>
      }
      <div class="rb-item__content">
        <formly-field [field]="fg"></formly-field>
      </div>
      <!-- remove button for simple RULES (existing behavior) -->
      @if (isRule(i)) {
        <div class="rb-item__actions">
          <button type="button" mat-icon-button color="warn" matTooltip="Remove" (click)="remove(i)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      }
    </div>
  }
</div>
